/**
 * Labstep
 *
 * @module prosemirror/extensions/commands/commands/selectors
 * @desc Selectors for commands plugin
 */

import { commandsPluginKey } from 'labstep-web/prosemirror/extensions/slash/plugin';
import type { PluginState } from 'labstep-web/prosemirror/extensions/slash/plugin/types';
import { sortElementsBySection } from 'labstep-web/prosemirror/extensions/slash/utils/sort-elements';
import type { EditorState } from 'prosemirror-state';

/**
 *
 * @description Returns the plugin state
 * @param state
 * @returns object
 */
export const getState = (state: EditorState): PluginState => {
  return state.plugins
    .find((p) => p.spec.key === commandsPluginKey)!
    .getState(state);
};

/**
 *
 * @description Returns isOpen of commands plugin
 * @param state
 * @returns boolean
 */
export const getIsOpen = (state: EditorState) => {
  return getState(state).isOpen;
};

/**
 *
 * @description Returns index of commands plugin
 * @param state
 * @returns string
 */
export const getIndex = (state: EditorState) => {
  return getState(state).index;
};

/**
 *
 * @description Returns elements of commands plugin
 * @param state
 * @returns string
 */
export const getAvailableElements = (state: EditorState) => {
  const pluginState = getState(state);
  const elements =
    pluginState.submenuElements || pluginState.availableElements;

  // If we have elements, sort them by section for consistent visual order
  if (elements && elements.length > 0) {
    return sortElementsBySection(elements);
  }

  return elements;
};

export const getSubmenuParent = (state: EditorState) => {
  return getState(state).submenuParent;
};

export const getIsInSubmenu = (state: EditorState) => {
  return !!getState(state).submenuParent;
};
